<template>
  <div class="step-two">
    <div class="main">
      <div class="icon icon-logo2"></div>
      <p class="sub-title">芒果TV全新声音治愈类真人秀</p>
      <p class="main-title">《朋友请听好》第二季故事招募</p>
      <div class="pannel">
        <p class="pannel-title">
          <span>节目录制保证书</span>
        </p>
        <div class="pannel-content">
          <p>
            《朋友请听好2》系由湖南快乐阳光互动娱乐传媒有限公司（以下简称“节目制作方”）制作播出的真人秀节目。根据国家广播电影电视总局以及相关法律法规。报名者使用虚假、欺诈手段报名，产生相关法律后果自行承担。
          </p>
          <p>
            参与报名者完成报名手续（见附件报名表），即表示完全理解节目一切规则，并同意作出本保证书项下承诺：
          </p>
          <p>
            1、本人自愿参加节目录制，愿意严格遵守节目制作方关于节目录制规程，并同意自行承担因违反节目录制规程导致的全部责任。
          </p>
          <p>
            2、本人理解并同意节目制作方，或由节目制作方共同选定的节目播出平台有权随时：
          </p>
          <p>（1）要求本人出示身份证明文件。</p>
          <p>
            （2）在本人违反节目规则或在本保证书项下承诺时，取消本人节目录制资格。
          </p>
          <p>（3）因节目播出原因修改节目录制方案。</p>
          <p>（4）因节目播出原因修改节目录制日期。</p>
          <p>
            3、本人同意，报名及在节目录制过程中填写与呈交的资料与文件、参加节目录制所形成的摄影资料、音频、视频资料由节目制作方保留，并同意无论节目录制进行中或终止后，无论任何原因中途退出节目录制，均无权索回该等资料。本人进一步同意授予节目制作方无偿使用上述资料权利，包括但不限于将该等资料用于任何与节目录制或节目相关的宣传及推广，如：
          </p>
          <p>（1）全世界范围内与节目录制有关的宣传、推广及申请赞助的活动。</p>
          <p>（2）全世界范围内制作与节目录制有关的电视、音像等相关作品。</p>
          （3）全世界范围内播放、推广、发行与节目录制有关的电视节目。
          <p>
            （4）全世界范围内以广播、网络、无线方式及可能产生的一切传播途径推广发行节目制作有关的内容。
          </p>
          <p>
            4、本人保证所提供个人资料真实、准确；本人同意若节目制作方发现提供的个人资料有任何不正确及不真实嫌疑时，有权要求本人作出修正，并有权要求其对新闻界、其他传媒、广告商及公众人士作出解释说明，节目制作方保留对本人实施任何制裁，包括但不限于取消节目录制资格的权利。如若因出现虚假信息造成一切不良后果均与节目制作方无关，需自行承担相应后果。
          </p>
          <p>
            5、本人保证：向节目制作方提供的故事脚本均为原创，未侵犯任何第三方的合法权益，或在节目录制过程中，发表含有破坏国家统一、宣秧恐怖主义、民族仇恨、民族歧视、血腥暴力、色情等违反国家法律法规等内容，否则，节目制作方有权取消录制资格，且有权要求支付人民币50万元的违约金，若违约金不足以弥补节目制作方损失的，还应继续赔偿。
          </p>
          <p>
            6、本人同意并保证：无论在节目录制进行中或终止后，无论因任何原因中途退出录制，在参加节目录制期间及参与相关活动期间所产生的著作权，均由节目制作方享有完整；同意节目制作方可自行或授权他人使用前述权利，以任何形式（包括但不限于公开播放、上映、传输、复制、改编、编辑、出版发行、网络下载等一切手段）开发影音、娱乐、文化出版、网络等产品；本人亦同意在节目录制进行期间及节目录制结束后任何时间，为宣传推广节目或行使上述表演著作权时，节目制作方可以无偿使用本人肖像、声音或其他形象。
          </p>
          <p>
            7、本人同意若有违反本保证书项下任何承诺，愿意承担因此产生的全部法律责任，包括但不限于赔偿节目制作方全部损失（包括直接损失和间接损失），节目录制主办方有权取消本人节目录制资格。
          </p>
          <p>
            8、若本保证书中的某一条款或某一条款中的部分表述无效，仍不影响其他条款或其他描述的法律效力。
          </p>
          <p>
            9、因本保证书发生任何争议的，应友好协商解决，协商不成的，可向长沙市开福区人民法院诉讼解决。
          </p>
          <p>
            10、本人保证在签署本保证书时已经详细阅读并理解了本保证书的全部内容，本人同意无条件遵守此保证书，且在完全自愿情况下签署本保证书。未成年人须在法定监护人陪同下签署本协保证书。
          </p>
        </div>
      </div>
      <div class="btn-normal" @click="onClickBtn">同意协议，继续参与招募</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onClickBtn() {
      this.$emit("next");
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";

.step-two {
  .btn-normal {
    @include px2vw(font-size, 32);
    padding: 0.75em 0;
    width: 100%;
  }
  .btn {
    position: relative;
    background-image: url("~@/assets/img/btn-2.png");
    @include px2vw(width, 305);
    @include px2vw(height, 85);
    @include px2vw(line-height, 85);
    @include px2vw(font-size, 35);
    font-weight: bold;
    margin: 0 auto;
  }
  .btn-wrapper {
    position: relative;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 85);
  }
  .main {
    @include px2vw(padding-top, 60);
    @include px2vw(width, 630);
    margin: 0 auto;
    color: #333333;
    text-align: center;
    @include px2vw(font-size, 24);
    @include px2vw(line-height, 33);
  }

  .main-title {
    font-weight: 500;
    @include px2vw(line-height, 50);
    @include px2vw(font-size, 36);
  }
  .sub-title {
    font-weight: 500;
    @include px2vw(line-height, 40);
    @include px2vw(font-size, 28);
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 20);
  }

  .icon {
    &-logo2 {
      margin: 0 auto;
    }
    &-cat {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translateY(100%);
    }
    &-line3 {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translate(50%, 55%);
    }
  }

  .line-wrapper {
    position: relative;
  }
  .pannel {
    &-title {
      flex: 1;
      @include px2vw(font-size, 32);
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &::after {
        display: block;
        content: '';
        width: 100%;
        height: 1px;
        background: black;
        position: absolute;
        left: 0;
        top: 50%;
      }
      & span {
        display: inline-block;
        @include px2vw(line-height, 45);
        padding: 0 0.5em;
        background: #f4f4f4;
        position: relative;
        z-index: 2;
      }
    }
    &-content {
      flex-shrink: 0;
      text-align: left;
      text-indent: 2em;
      @include px2vw(font-size, 28);
      @include px2vw(line-height, 40);
      @include px2vw(height, 515);
      overflow-x: hidden;
    }
    position: relative;
    @include px2vw(width, 630);
    @include px2vw(height, 618);
    margin: 0 auto;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 40);
    @include px2vw(padding-left, 30);
    @include px2vw(padding-right, 30);
    background: #f4f4f4;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }
}
</style>
